import React from "react";
import {
    Button,
    Stack,
    Heading,
    Text,
    Container,
    Link,
    Divider,
    Image,
} from "@dgraph-io/typhoon-ui";
import { ReactComponent as GithubIcon } from "./icons/github.svg";
import { styles } from "./AppStore.styles";
import PropTypes from "prop-types";
import BackButton from "components/shared/BackButton/BackButton";

function SampleAppDetail({ app, onClick, show }) {
    return (
        <>
            <BackButton text="Back" onClick={onClick} />

            <Divider />

            <Stack fullWidth gap={5} styles={styles.SampleAppDetail}>
                <Image
                    src={app.image}
                    styles={styles.ImageStyles}
                    alt={app.name}
                    fullWidth={false}
                />

                <Container styles={styles.SampleAppDetailContainer}>
                    <Heading variant={2}>{app.name}</Heading>

                    <Text variant={2} color="grey">
                        {app.date}
                    </Text>

                    <Text
                        variant={2}
                        weight="600"
                        styles={{ paddingBottom: 1 }}
                    >
                        License: {app.license}
                    </Text>

                    <Divider />

                    <Link href={app.frontendRepo} openInNewTab>
                        <Stack align="center" gap={1} styles={{ marginY: 1 }}>
                            <GithubIcon height="15px" width="15px" />
                            <Text variant={3}>View code</Text>
                        </Stack>
                    </Link>

                    <Stack>
                        <Button
                            onClick={show}
                            disabled={app ? false : true}
                            styles={{ marginY: 1 }}
                        >
                            Deploy
                        </Button>
                        {app.hostedUrl && (
                            <Link href={app.hostedUrl} openInNewTab>
                                <Button
                                    variant="murmur"
                                    styles={{ marginY: 1, marginX: 1 }}
                                >
                                    View App
                                </Button>
                            </Link>
                        )}
                    </Stack>
                </Container>
            </Stack>

            <Divider />

            <Heading variant={2} styles={{ paddingY: 2 }}>
                Overview
            </Heading>

            <Text styles={styles.OverviewTextStyles}>{app.description}</Text>
            <Stack styles={{ marginBottom: 2 }}>
                <Text weight="600">Front-end: &nbsp;</Text>
                {app.frontend.length > 0 &&
                    app.frontend.map((ele, index) => {
                        return (
                            <Text key={index}>{index ? ", " : "" + ele}</Text>
                        );
                    })}
            </Stack>

            <Stack styles={{ marginBottom: 2 }}>
                <Text weight="600">Back-end: &nbsp;</Text>
                {app.backend.length > 0 &&
                    app.backend.map((ele, index) => {
                        return (
                            <Text key={index}>{(index ? ", " : "") + ele}</Text>
                        );
                    })}
            </Stack>

            <Stack gap={1} direction="vertical" styles={{ marginBottom: 2 }}>
                {app.features && app.features.length > 0 && (
                    <Text weight={600}>Features</Text>
                )}

                {app.features &&
                    app.features.length > 0 &&
                    app.features.map((ele, index) => {
                        return (
                            <Text key={index}>
                                <li>{ele}</li>
                            </Text>
                        );
                    })}
            </Stack>
        </>
    );
}

SampleAppDetail.propTypes = {
    onClick: PropTypes.func,
    show: PropTypes.func,
    app: PropTypes.object,
};

export default SampleAppDetail;
